import { Float, Text } from "@react-three/drei";
import { floor1Material } from "../utils/materials";
import { boxGeometry } from "../utils/geometries";

export function BlockStart({ position = [0, 0, 0] }) {
  return (
    <group position={position}>
      <Float floatIntensity={0.25} rotationIntensity={0.25}>
        <Text
          scale={0.5}
          font="./bebas-neue-regular.ttf"
          maxWidth={0.25}
          lineHeight={0.75}
          textAlign="right"
          position={[0.75, 0.65, 0]}
          rotation-y={-0.25}
        >
          Speed Race
          <meshBasicMaterial toneMapped={false} />
        </Text>
      </Float>
      <mesh
        material={floor1Material}
        geometry={boxGeometry}
        position={[0, -0.1, 0]}
        scale={[4, 0.2, 4]}
        receiveShadow
      />
    </group>
  );
}
